// @flow
import type { FSA } from 'types/redux';
import { API_REQUEST } from 'middlewares/api-middleware';

export const GET_RULE_TYPES = 'GET_RULE_TYPES';
export function getRuleTypes(
  type: string = 'PROMOTION',
  searchParams: Object = {}
): FSA {
  // TODO: should separate getRuleTypes for reward and treatments.
  // Need time to refactor the RuleBuilder and related components.
  const typeSegs = type.split('.');
  const ruleCat = typeSegs[0];
  const ruleType = typeSegs[1];

  // this piece of code is to handle getRuleType call for condition node where we need to fetch rules for two eventTypes in case of chain scenario.
  let treatmentUrl = `/treatments/rule-types?eventType=${ruleType}`;
  let treatmentActionMetaType = ruleType;
  if (ruleCat === 'TREATMENTS' && typeSegs.length > 2) {
    treatmentUrl = `/treatments/rule-types?eventType=${typeSegs[1]}&eventType=${typeSegs[2]}`;
    treatmentActionMetaType = typeSegs[1].concat(typeSegs[2]);
  }

  if (ruleCat === 'POINT_CAMPAIGNS') {
    let url = '/abacus/rule-types';

    if (searchParams && searchParams.campaignType) {
      let campaignType = searchParams.campaignType;
      // normalize ACCELERATED_BASE_MDR type to ACCELERATED
      if (campaignType === 'ACCELERATED_BASE_MDR') {
        campaignType = 'ACCELERATED';
      }

      url = `/abacus/rule-types?campaignType=${campaignType}`;
    }

    return {
      type: GET_RULE_TYPES,
      payload: {
        method: 'GET',
        url,
      },
      meta: {
        [API_REQUEST]: true,
        type,
      },
    };
  }

  if (ruleCat === 'TREATMENTS') {
    return {
      type: GET_RULE_TYPES,
      payload: {
        method: 'GET',
        url: treatmentUrl,
      },
      meta: {
        [API_REQUEST]: true,
        type: treatmentActionMetaType,
      },
    };
  }

  if (ruleCat === 'SUBSCRIPTIONS') {
    return {
      type: GET_RULE_TYPES,
      payload: {
        method: 'GET',
        url: '/subscription/rule-types',
      },
      meta: {
        [API_REQUEST]: true,
        type,
      },
    };
  }

  if (ruleCat === 'QUEST') {
    return {
      type: GET_RULE_TYPES,
      payload: {
        method: 'GET',
        url: '/quest/rule-types',
      },
      meta: {
        [API_REQUEST]: true,
        type,
      },
    };
  }

  if (ruleCat === 'OFFERS_DISCOVERY') {
    return {
      type: GET_RULE_TYPES,
      payload: {
        method: 'GET',
        url: '/offersdiscovery/rule-types',
      },
      meta: {
        [API_REQUEST]: true,
        type,
      },
    };
  }

  if (ruleCat === 'STINGRAY') {
    let defaultParam = '';
    if (searchParams.isListWithDefault) {
      defaultParam = '&isListWithDefault=true';
    }
    if (searchParams.type !== '') {
      defaultParam += `&type=${searchParams.type}`;
    }
    return {
      type: 'GET_RULE_TYPES',
      payload: {
        method: 'GET',
        url: `/stingray/partners/${searchParams.partnerID}/scopes/ruletypes?scopeIDs=${searchParams.scopeID}${defaultParam}`,
      },
      meta: {
        [API_REQUEST]: true,
        type: ruleType,
      },
    };
  }

  // General
  return {
    type: GET_RULE_TYPES,
    payload: {
      method: 'GET',
      url: `/rule-types?rewardType=${type}`,
    },
    meta: {
      [API_REQUEST]: true,
      type,
    },
  };
}

export const GET_RULE_OBJECT_TYPES = 'GET_RULE_OBJECT_TYPES';
export function getRuleObjectTypes(): FSA {
  return {
    type: GET_RULE_OBJECT_TYPES,
    payload: {
      method: 'GET',
      url: '/object-types',
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}
